// extracted by mini-css-extract-plugin
export default {"root":"styles_root__nSOx8","alert":"styles_alert__zLqAU","approve":"styles_approve__gb2Ep"};